/** @type {string} */
const scrollspyComponent = "ScrollSpy";
export default scrollspyComponent;
